import React, { useEffect, useRef, useState } from 'react'

const ProtectedPage = ({ password, children, enablePasswordProtected }) => {
    const [isPassword, setIsPassword] = useState(
        Boolean(enablePasswordProtected)
    )
    const passwordRef = useRef(null)
    const handleSubmit = (e) => {
        e.preventDefault()
        const inputPassword = passwordRef?.current?.value

        if (inputPassword === password) {
            setIsPassword(false)
            return
        }

        alert('Wrong password, please try again!')
    }
    // useEffect(() => {
    //     if (password) {
    //         setIsPassword(true)
    //     } else setIsPassword(false)
    // }, [])

    if (!isPassword || !enablePasswordProtected) {
        return <>{children}</>
    }
    return (
        <div className="fixed inset-0 grid place-items-center">
            <div>
                <svg
                    id="Layer_2"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1428.16 393.54"
                >
                    <g id="Layer_1-2">
                        <g>
                            <polygon points="482.23 70.68 482.23 306.2 532.19 306.2 532.19 70.68 532.19 0 482.23 0 482.23 70.68" />
                            <path d="M1371.22,81.29l-58.97,168.73-65.03-168.73h-56.3l94.51,232.57-2.79,6.47c-4.52,9.94-9.34,16.94-14.46,21.01-5.13,4.07-11.6,6.1-19.43,6.1-10.25,0-20.94-3.02-32.08-9.04l-18.53,40.67c17.77,9.64,36.6,14.46,56.49,14.46s34.79-5.05,46.54-15.14c11.75-10.09,22.44-27.34,32.08-51.74l94.9-245.37h-56.94Z" />
                            <path d="M998.77,2.64c-23.7-7.69-45.28,13.88-37.59,37.59,2.76,8.5,9.5,15.25,18,18,23.71,7.69,45.28-13.89,37.59-37.59-2.76-8.5-9.5-15.24-18-18Z" />
                            <path d="M673,75.71c-65.36,0-120.55,51.62-120.55,116.98s55.18,119.88,120.55,119.88c45.31,0,84.63-27.02,104.51-64.42l-43.82-15.64c-12.98,19.76-35.29,32.84-60.7,32.84-33,0-60.85-22.01-69.71-52.14h186.24c1.17-6.67,1.81-13.52,1.81-20.52,0-65.36-52.99-116.98-118.35-116.98Zm-68.64,90.57c9.87-25.85,36.87-44.52,68.64-44.52s57.56,18.67,67.43,44.52h-136.07Z" />
                            <rect
                                x="962.33"
                                y="81.29"
                                width="53.3"
                                height="224.93"
                            />
                            <path d="M1160.26,263.88c-19.59,0-29.37-9.94-29.37-29.83v-106.04h49.32v-47h-49.32V31.47h-50.28v49.54h-39.23v47h37.03v114.63c0,37.45,22.89,70.04,68.69,70.04,18.21,0,32.3-4.01,46.66-12-7.31-13.92-13.69-30.23-17.23-39.18-4.87,1-11.22,2.38-16.26,2.38Z" />
                            <path d="M341.68,75.82c-74.41,0-106.03,59.71-131.43,107.69-26.6,50.23-47.29,83.16-90.69,83.16s-73.45-30.44-73.45-72.38,30.89-73.73,73.45-73.73c25.58,0,43.26,11.45,58.92,31.12h0s27.03-39.4,27.03-39.4c-20.63-21.95-47.59-37.83-85.95-37.83C51.4,74.47,0,121.76,0,194.3c0,67.55,51.4,118.48,119.56,118.48,74.41,0,106.03-59.71,131.43-107.69,26.6-50.23,47.28-83.16,90.69-83.16,32.31,0,57.88,17.55,68.33,44.36h-110.09c-5.72,7.2-14.64,20.79-27.09,46.19h187.77s.64-3.67,.64-18.17c0-67.55-51.39-118.48-119.55-118.48Z" />
                            <path d="M341.68,266.67c-31.89,0-59.44-18.63-75.02-41.81-12.12,23.67-20.62,35.54-25.7,41.37,24.32,27.08,59.89,46.55,100.72,46.55,48.15,0,87.9-25.44,107.11-64.17l-43.97-15.69c-12.48,20.74-35.31,33.76-63.14,33.76Z" />
                            <path d="M890.98,82.26c-7.58,3.79-16.27,10.16-26.06,20.42v-21.4h-53.3v224.93h53.3v-113.03c0-72.74,49.69-63.18,73.2-54.96l1.04-56.62c-6.24-2.53-14.6-4.82-21.02-4.82-10.58,0-19.43,1.53-27.16,5.48Z" />
                        </g>
                    </g>
                </svg>
                <form onSubmit={handleSubmit}>
                    <div className="mt-2 mb-5">
                        <input
                            id="password"
                            name="password"
                            type="password"
                            placeholder="password"
                            autoComplete="current-password"
                            required
                            ref={passwordRef}
                            className="block w-full px-3 rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-dark_purple sm:text-sm sm:leading-6"
                        />
                    </div>
                    <div>
                        <button
                            type="submit"
                            className="flex w-full justify-center rounded-md bg-dark_purple px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-dark_purple/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-darbg-dark_purple"
                        >
                            Sign in
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ProtectedPage
